 import React, { useContext, useState, useEffect } from 'react';
import { FormWrapper, 
         ButtonStyled,
         ButtonTextStyled } from './styles';
import { ContentContext } from '../../context/ContentContext';
import { validateEmail } from '../helpers/functions';
import { IoClose } from "react-icons/io5";
import { CircularProgress } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { IoEye, IoEyeOff } from "react-icons/io5";

const FormRecovery = (props) => {
    
    const location = useLocation();
    const navigate = useNavigate();

    const { dataSaved, 
            setDataSaved,
            showLogin,
            setShowLogin,
            setShowRegistro,
            setShowForgot,
            setScope,
            trigger,
            setOpenSnackbar,
            setSnackbarMessage,
            setSnackbarVariant,
            setShowRecovery } = props;

    const { change_password } = useContext(ContentContext);

    const [ formData, setFormData ] = useState({ password: { value:"", error: false, mandatory: true },
                                                 repeat_password: { value:"", error: false, mandatory: true }, });
                                                 
    const [ isLoading, setIsLoading ] = useState(false);
    const [ showPassword, setShowPassword ] = useState(false);
    const [ showRepeatPassword, setShowRepeatPassword ] = useState(false);
    const [ token, setToken ] = useState("");

    const handleOnChanceForm = (e, name) => {
        
        let formData_update = {...formData};

        formData_update[name].value = e.target.value;

        switch (name) {
            case "name":
                //formData_update[name].value = e.target.value;
                break;
        
            default:
                break;
        }

        setFormData(formData_update);

    }
    console.log("location", location)
    const handleSaveData = () => {

        setIsLoading(true);
        let haveError = false;

        let formDataValidate = {...formData};
        Object.keys(formDataValidate).map((field) => {
            
            if(formDataValidate[field].mandatory){
                if(!formDataValidate[field].value.length){
                    haveError = true;
                    formDataValidate[field].error =  true;
                }else{
                    formDataValidate[field].error =  false;
                }
            }

            if(formDataValidate["password"].value !== formDataValidate["repeat_password"].value){
                haveError = true;
                formDataValidate["password"].error =  true;
                formDataValidate["repeat_password"].error =  true;
            }

            /*
            if(field === "password"){
                if(!validateEmail(formDataValidate[field].value)){
                    haveError = true;
                    formDataValidate[field].error =  true;
                }else{
                    formDataValidate[field].error =  false;
                }
                console.log(validateEmail(formDataValidate[field].value));
            }
            */
            
        })
        setFormData(formDataValidate);
        
        if(!haveError){
            const payload = {password: formData["password"].value, token: token};
            //console.log("payload", payload);
            //return null;
            const response = change_password(payload);
            response.then(res => {
                setIsLoading(false);
                if(res.data.success){

                    setOpenSnackbar(true);
                    setSnackbarMessage("Tu contraseña se modificó con éxito.");
                    setSnackbarVariant("success");

                    setShowLogin(true);       
                    setShowRegistro(false); 
                    setShowRecovery(false);
                    setShowForgot(false);
                    setScope("login");
                    
                    resetForm();
                    
                    navigate(location.pathname, { replace: true });
                    //window.location.reload();

                }else{

                    setOpenSnackbar(true);
                    setSnackbarMessage("Hubo un error al intentar modificar tu contraseña, por favor asegurate de haber accedido desde el link que te enviamos via E-Mail.");
                    setSnackbarVariant("error");

                }
                console.log("🚀 sendLogin", res)
            })
        }else{
            setIsLoading(false);
        }
        console.log("formData", formData);

    }

    const handleClose = () => {
        setScope(null);
    }

    const handleGotoLogin = () => {
        setShowLogin(true);
        setShowRegistro(false);
        setShowForgot(false);
        setShowRecovery(false);
    }

    const handleShowPass = (field) => {

        switch (field) {
            case "password":
                setShowPassword(!showPassword)
                break;
            case "repeat_password":
                setShowRepeatPassword(!showRepeatPassword)
                break;
            default:
                break;
        }
    }

    const resetForm = () => {

        let formReset = {...formData};
        Object.keys(formReset).map((field) => {
            formReset[field].value = "";
            formReset[field].error = false;
        })
        setFormData(formReset);

    }

    useEffect(() => {

        const query = new URLSearchParams(location.search);
        if(query.get("token") && query.get("token").length > 0){
          console.log("🚨", query.get("token"))
          setToken(query.get("token"));
        }

        return () => {}
      }, [])
    

    return (
        <FormWrapper>
            <div className='inner'>
                <div className='bt_close' onClick={handleClose}>
                    <p><IoClose /></p>
                </div>
                <div className='fields'>
                    <div className='field'>
                        <label>Constraseña {formData.password.mandatory ? "*" : ""}</label>
                        <input 
                            className={`${formData.password.error ? " error" : ""}`}
                            type={showPassword ? "text" : "password"} 
                            value={formData.password.value} 
                            onChange={(e) => handleOnChanceForm(e, "password")}
                        />
                        <div className='show_pass' onClick={() => handleShowPass("password")}>
                            {!showPassword ?
                            <IoEye />
                            : 
                            <IoEyeOff />
                            }
                        </div>
                    </div>
                    <div className='field'>
                        <label>Repetir Constraseña {formData.repeat_password.mandatory ? "*" : ""}</label>
                        <input 
                            className={`${formData.repeat_password.error ? " error" : ""}`}
                            type={showRepeatPassword ? "text" : "password"} 
                            value={formData.repeat_password.value} 
                            onChange={(e) => handleOnChanceForm(e, "repeat_password")}
                        />
                        <div className='show_pass' onClick={() => handleShowPass("repeat_password")}>
                            {!showRepeatPassword ?
                            <IoEye />
                            : 
                            <IoEyeOff />
                            }
                        </div>
                    </div>
                </div>

                <div className='aclaration_asterix'>Los campos con * son obligatorios</div>
                
                <div className='actions'>
                    {!isLoading ? 
                        <ButtonStyled onClick={() => handleSaveData()}>
                            Enviar
                        </ButtonStyled>
                    :
                        <div className='loader'>
                            <CircularProgress />
                        </div>
                    }
                    <ButtonTextStyled onClick={() => handleGotoLogin()}>
                        INGRESAR
                    </ButtonTextStyled>
                </div>
            </div>
        </FormWrapper>
    );
};

export default FormRecovery;